// @flow
import { connect } from 'react-redux';
import type { ExtractReturn } from '../../types/redux';
import { getNotificationCount } from '../../redux/modules/notification';
import { PureComponent } from 'react';

type OwnProps = $ReadOnly<{||}>;

const mapStateToProps = (state: any) => {
    const count = getNotificationCount(state);
    return { count };
};

type ReduxProps = $ReadOnly<{|
    ...ExtractReturn<typeof mapStateToProps>,
    count: number,
|}>;

type Props = $ReadOnly<{|
    ...OwnProps,
    ...ReduxProps,
|}>;

class NotificationCountTitle extends PureComponent<Props> {
    componentDidUpdate(prevProps) {
        const { count } = this.props;
        const replace = /\(\d+\)/;
        if (document?.title) {
            if (count > 0) {
                document.title = `(${count}) ${document.title.replace(replace, '')}`;
            } else if (prevProps.count > 0) {
                document.title = document.title.replace(replace, '');
            }
        }
    }
    render() {
        return null;
    }
}

export default connect(mapStateToProps)(NotificationCountTitle);
